export default __webpack_public_path__ + "static/media/rahul_lamba.c1f40179.jpeg";